/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupArtistsQuery
 */
export interface LookupArtistsQuery {
    /**
     * Search term for artist lookup
     * @type {string}
     * @memberof LookupArtistsQuery
     */
    searchTerm: string;
}

/**
 * Check if a given object implements the LookupArtistsQuery interface.
 */
export function instanceOfLookupArtistsQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "searchTerm" in value;

    return isInstance;
}

export function LookupArtistsQueryFromJSON(json: any): LookupArtistsQuery {
    return LookupArtistsQueryFromJSONTyped(json, false);
}

export function LookupArtistsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupArtistsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchTerm': json['search_term'],
    };
}

export function LookupArtistsQueryToJSON(value?: LookupArtistsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'search_term': value.searchTerm,
    };
}

